import React from 'react';
import PropTypes from 'prop-types';
import { trackingURL } from '@xingternal/xing-tracking';
import { trackings } from '../../../tracking';
import { Item } from '../Item';
import { Section } from './components';
export default function RecentInteractionsSection({ baseI, highlightedIndex, section: { title, items }, getItemProps, userId, searchType, }) {
    // clean up items with XingId: null
    const filteredItems = items.filter((el) => el.xingId);
    return (React.createElement(Section, { type: "recent-interactions", headline: title }, filteredItems.map(({ trackingToken, xingId: { pageName, displayName, profileImage } }, i) => {
        const position = baseI + i;
        const isHighlighted = position === highlightedIndex;
        return (React.createElement(Item, { getItemProps: getItemProps, key: trackingToken, data: {
                thumbnail: profileImage && profileImage.length
                    ? profileImage[0].url
                    : undefined,
                title: displayName,
                url: trackingURL(`/profile/${pageName}`, 'result')(trackings),
                trackingToken,
                position,
                userId,
            }, searchType: searchType, isHighlighted: isHighlighted }));
    })));
}
RecentInteractionsSection.propTypes = {
    baseI: PropTypes.number.isRequired,
    highlightedIndex: PropTypes.number,
    getItemProps: PropTypes.func.isRequired,
    userId: PropTypes.string.isRequired,
    searchType: PropTypes.string.isRequired,
    section: PropTypes.shape({
        title: PropTypes.string.isRequired,
        items: PropTypes.arrayOf(PropTypes.shape({
            xingId: PropTypes.shape({
                displayName: PropTypes.string.isRequired,
                pageName: PropTypes.string.isRequired,
                profileImage: PropTypes.arrayOf(PropTypes.shape({
                    url: PropTypes.string.isRequired,
                })),
            }).isRequired,
            trackingToken: PropTypes.string.isRequired,
        })).isRequired,
    }).isRequired,
};
//# sourceMappingURL=RecentInteractions.js.map